import { render } from "./GeneralSetting.vue?vue&type=template&id=829100b2"
import script from "./GeneralSetting.vue?vue&type=script&lang=js"
export * from "./GeneralSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__